/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Import_FailedInputs */

const en_editor_import_failed = /** @type {(inputs: Editor_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Failed`)
};

const fr_editor_import_failed = /** @type {(inputs: Editor_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec de l'importation`)
};

const de_editor_import_failed = /** @type {(inputs: Editor_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import fehlgeschlagen`)
};

const it_editor_import_failed = /** @type {(inputs: Editor_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione non riuscita`)
};

const ru_editor_import_failed = /** @type {(inputs: Editor_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт не удался.`)
};

const es_editor_import_failed = /** @type {(inputs: Editor_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación fallida`)
};

const zh_cn2_editor_import_failed = /** @type {(inputs: Editor_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入失败`)
};

const ja_editor_import_failed = /** @type {(inputs: Editor_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポートに失敗しました`)
};

const hi_editor_import_failed = /** @type {(inputs: Editor_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात विफल`)
};

const pt_pt2_editor_import_failed = /** @type {(inputs: Editor_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação falhou`)
};

/**
* | output |
* | --- |
* | "Import Failed" |
*
* @param {Editor_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_import_failed = /** @type {((inputs?: Editor_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_import_failed(inputs)
	if (locale === "de") return de_editor_import_failed(inputs)
	if (locale === "it") return it_editor_import_failed(inputs)
	if (locale === "ru") return ru_editor_import_failed(inputs)
	if (locale === "es") return es_editor_import_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_import_failed(inputs)
	if (locale === "ja") return ja_editor_import_failed(inputs)
	if (locale === "hi") return hi_editor_import_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_import_failed(inputs)
	return en_editor_import_failed(inputs)
});